import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAllProductsShop } from "../../redux/actions/product";
import { server } from "../../server";
import ShopInfo from "../../components/Shop/ShopInfo";
import ShopProfileData from "../../components/Shop/ShopProfileData";
import ShopBanner from '../../components/Shop/ShopBanner';
import Header from '../../components/Layout/Header';
import Sidebar from '../../components/Layout/Sidebar';
import MixedSponsoredAds from '../../components/Sponsored/MixedSponsoredAds';
import FollowButton from '../../components/Connections/FollowButton';
import MyPostWidgetRedux from '../../widgets/MyPostWidgetRedux';
import ShopAvatar from '../../components/Shop/ShopAvatar';
import RoomsProfile from '../../components/Rooms/RoomsProfile';
import MyContentCarousel from '../../components/Profile/MyContentCarousel';
import MyShopImages from '../../components/Content/MyShopImages';
import EventsParentContainer from '../../components/Events/EventsParentContainer';
import ShopConnectionStats from '../../components/Connections/ShopConnectionStats';
import RecommendedFriends from '../../components/Followers/RecommendedFriends';

const ShopPreviewPage = () => {
  const [shop, setShop] = useState({});
  const { handle } = useParams();
  const dispatch = useDispatch();
  const { seller, activeSeller, sellers: sellerProfiles = [] } = useSelector((state) => state.seller);
  const shopHandle = shop?.handle || handle;
  const normalizeHandle = (value) => String(value || '').trim().replace(/^@/, '').toLowerCase();
  const loggedInShopIds = [seller?._id, activeSeller?._id, ...sellerProfiles.map((profile) => profile?._id)]
    .filter(Boolean)
    .map(String);
  const loggedInShopHandles = [seller?.handle, activeSeller?.handle, ...sellerProfiles.map((profile) => profile?.handle)]
    .map(normalizeHandle)
    .filter(Boolean);
  const isOwner =
    Boolean(shop?._id && loggedInShopIds.includes(String(shop._id))) ||
    Boolean(shopHandle && loggedInShopHandles.includes(normalizeHandle(shopHandle)));
  
  useEffect(() => {
    // Fetch shop info and products
    axios.get(`${server}/shop/handle-to-id/${handle}`)
      .then(res => {
        const id = res.data.id;
        dispatch(getAllProductsShop(id));
        return axios.get(`${server}/shop/get-shop-info/${id}`);
      })
      .then(res => setShop(res.data.shop))
      .catch(error => console.log(error));
  }, [handle, dispatch]);

  return (
    <div className={`profile-page shop-profile-page${isOwner ? ' profile-owner-view' : ''}`}>
      <Header />
      <Sidebar />
      <div className="shop-profile-container">
        {/* Shop Banner */}
        <ShopBanner isOwner={isOwner} shop={shop} setShop={setShop} />

        <div className="profile-info-container shop-profile-info-container">
          <div className="profile-hero-layout shop-profile-hero-layout">
            <div className="shop-avatar-profile-wrapper">
              <div className="shop-info-sidebar-avatar-container">
                <ShopAvatar shop={shop} />
              </div>
            </div>

            <div className="profile-info">
              <div className="profile-name-wrapper">
                <div className="profile-name-and-button">
                  <h3 className="profile-name">{shop?.name || "Shop"}</h3>
                </div>
                {shopHandle && <h3 className="profile-handle shop-profile-handle">@{shopHandle}</h3>}

                {shop && shop._id && (
                  <>
                    <ShopConnectionStats userId={shop?._id} profileType="Shop" />

                    {!isOwner && (
                      <FollowButton
                        className="profile-followers-add-button shop-profile-follow-button"
                        connectionId={shop?._id}
                        connectionType="Shop"
                      />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="profile-main-content">
        <aside className="profile-sidebar-left">
        {shop && shop._id && (
          <>
          <RoomsProfile profileId={shop?._id} profileType="Shop" canCreate={isOwner} showActionMenu />
          <MyShopImages shopId={shop?._id} ownerName={shop?.name} ownerAvatar={shop?.avatar?.url} />
          <EventsParentContainer ownerId={shop?._id}/>
          
          </>
        )}

         
          <ShopInfo isOwner={isOwner} />
        </aside>

        <main className="shop-profile-main-area">
          <div id="profile-post-composer" className="profile-post-composer-anchor">
            <MyPostWidgetRedux />
          </div>
          {shop && shop._id && (
            <div className="profile-feature-widget-row profile-mobile-feature-widget-row" aria-label="Shop media widgets">
              <section className="profile-feature-widget profile-feature-widget-photos">
                <MyShopImages shopId={shop?._id} canAddPhotos={isOwner} showActionMenu ownerName={shop?.name} ownerAvatar={shop?.avatar?.url} />
              </section>
              <section className="profile-feature-widget profile-feature-widget-memes">
                <MyContentCarousel ownerId={shop?._id} profileType="Shop" canCreate={isOwner} showActionMenu />
              </section>
              <section id="profile-communities-widget" className="profile-feature-widget profile-feature-widget-communities">
                <RoomsProfile profileId={shop?._id} profileType="Shop" canCreate={isOwner} showActionMenu />
              </section>
            </div>
          )}
          <ShopProfileData isOwner={isOwner} shopData={shop} />
          {shop && shop._id && (
            <div className="profile-lower-mobile-stack" aria-label="Shop recommendations and sponsored content">
              <RecommendedFriends />
              <EventsParentContainer ownerId={shop?._id} />
              <MixedSponsoredAds />
            </div>
          )}
        </main>

        <aside className="shop-profile-sidebar-right">
          <MyContentCarousel ownerId={shop?._id} profileType="Shop" canCreate={isOwner} />
          <MixedSponsoredAds />
        </aside>
      </div>
    </div>
  );
};

export default ShopPreviewPage;

